import type { Menu, RecordEntityId, V2Menu } from '@centric-os/types';
import { defineStore, type StateTree } from 'pinia';
import { useStationMenus } from './composables';

interface State extends StateTree {
  stationMenu: V2Menu;
  stationMenus: (V2Menu | Menu)[];
}

export function useStationMenuStore(storeId = 'station-menu') {
  const store = defineStore(storeId, {
    state: (): State => ({
      stationMenu: null,
      stationMenus: [],
    }),
    actions: {
      async getStationBrandMenu(id: RecordEntityId): Promise<void> {
        const response = await this.serviceApi.get_menu(String(id));

        this.stationMenu = response as V2Menu;
      },
      async getAllMenusForStation(ids: RecordEntityId[], stationId: string): Promise<void> {
        const { useStationBrandMenus } = useStationMenus();
        const v2StationMenus = (await Promise.all(
          ids.map((id: RecordEntityId) => this.serviceApi.get_menu(String(id))),
        )) as V2Menu[];

        this.stationMenus = await useStationBrandMenus(v2StationMenus, stationId);
      },
    },
    pagination: false,
  });
  return store();
}
